(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page-petsthing-policy-faqs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-policy-faq]').forEach((page) => {
    const input = page.querySelector('[data-faq-search]');
    const empty = page.querySelector('[data-faq-empty]');
    if (!input || !empty) return;

    input.addEventListener('input', () => {
      const query = input.value.trim().toLocaleLowerCase();
      let visibleCount = 0;

      page.querySelectorAll('[data-faq-group]').forEach((group) => {
        let groupCount = 0;

        group.querySelectorAll('[data-faq-item]').forEach((item) => {
          const matches = !query || item.textContent.toLocaleLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) {
            groupCount += 1;
            visibleCount += 1;
          }
        });

        group.hidden = groupCount === 0;
      });

      empty.hidden = visibleCount !== 0;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-vip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (value) => String(value).padStart(2, '0');

    const getMonthEnd = () => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0, 0);
    };

    const initVipPage = () => {
      document.querySelectorAll('[data-vip-page]').forEach((section) => {
        if (section.dataset.vipReady === 'true') return;
        section.dataset.vipReady = 'true';

        const countdown = section.querySelector('[data-vip-countdown]');
        const sticky = section.querySelector('[data-vip-sticky]');
        const hero = section.querySelector('[data-vip-hero]');
        let countdownTimer;

        if (countdown) {
          const parts = {
            days: countdown.querySelector('[data-vip-days]'),
            hours: countdown.querySelector('[data-vip-hours]'),
            minutes: countdown.querySelector('[data-vip-minutes]'),
            seconds: countdown.querySelector('[data-vip-seconds]')
          };

          const updateCountdown = () => {
            const diff = Math.max(0, getMonthEnd().getTime() - Date.now());
            const seconds = Math.floor(diff / 1000);
            const days = Math.floor(seconds / 86400);
            const hours = Math.floor((seconds % 86400) / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = seconds % 60;

            if (parts.days) parts.days.textContent = pad(days);
            if (parts.hours) parts.hours.textContent = pad(hours);
            if (parts.minutes) parts.minutes.textContent = pad(minutes);
            if (parts.seconds) parts.seconds.textContent = pad(remainingSeconds);
          };

          updateCountdown();
          countdownTimer = window.setInterval(updateCountdown, 1000);
        }

        if (sticky && hero) {
          const toggleSticky = () => {
            const heroBottom = hero.getBoundingClientRect().bottom;
            sticky.classList.toggle('is-visible', heroBottom < 0);
          };

          toggleSticky();
          window.addEventListener('scroll', toggleSticky, { passive: true });
          window.addEventListener('resize', toggleSticky);

          section.addEventListener('shopify:section:unload', () => {
            window.removeEventListener('scroll', toggleSticky);
            window.removeEventListener('resize', toggleSticky);
            if (countdownTimer) window.clearInterval(countdownTimer);
          }, { once: true });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVipPage, { once: true });
    } else {
      initVipPage();
    }

    document.addEventListener('shopify:section:load', initVipPage);
  })();

  } catch(e) { console.error(e); }
})();
})();
